export function addParam(url: string, params: any) {
  const sp = url.indexOf('?') === -1 ? '?' : '&';
  const arr = [];
  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      const value = params[key] === undefined ? '' : params[key];
      arr.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  }
  if (arr.length) {
    url += sp + arr.join('&');
  }
  return url;
}

export function parseQuery(link?: string) {
  link = link || window.location.search;
  const query: any = {};
  const search = link.replace(/^\?/g, '');
  if (!search) {
    return {};
  }

  const a = search.split('&');
  let iequ;
  let value = null;

  for (let i = 0, len = a.length; i < len; i++) {
    // 必须用indexOf，不用使用split('=')
    iequ = a[i].indexOf('=');

    if (iequ < 0) {
      iequ = a[i].length;
      value = true;
    } else {
      value = decodeURIComponent(a[i].slice(iequ + 1));
    }

    query[decodeURIComponent(a[i].slice(0, iequ))] = value;
  }
  return query;
}
